<template>
  <v-dialog v-model="open" width="70%" @click:outside="cancel" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card class="main">
      <v-card-title class="primary white--text"
        ><v-toolbar-title>XEM TRƯỚC</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <div>
        <v-data-table
          :footer-props="{
            'items-per-page-text': 'Số dữ liệu mỗi trang',
            'items-per-page-options': [5, 10, 20]
          }"
          :headers="headers"
          :items="items"
          class="data-table has-border ma-2"
          disable-sort
          style="max-height: 65vh; overflow: auto"
        ></v-data-table>
      </div>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between">
        <v-btn @click="cancel" class="ma-2" outlined color="#0D47A1">Huỷ</v-btn>
        <div class="d-flex justify-end">
          <v-btn @click="reUpload" v-if="error" class="ma-2" outlined color="#0D47A1">Tải lại</v-btn>
          <v-btn @click="accept" :disabled="error" class="ma-2" color="#0D47A1" style="color:white">Xác nhận</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
      items: []
    }
  },
  methods: {
    openDialog(data) {
      this.items = data
      this.open = true
    },
    cancel() {
      this.$emit('cancel')
      this.open = false
    },
    accept() {
      this.$emit('accept')
      if (this.autoClose) {
        this.open = false
      }
    },
    reUpload() {
      this.$emit('reUpload')
    }
  }
}
</script>
<style scoped></style>
